import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {mortgageLoanAxios} from '@Root/utils/mortgageLoanApi';
import {FETCH_STATUS} from '@Root/contants';
import {TMortgagePartnerProductType} from '@Root/contants/myhouse';
import MortgagePartnerProduct from '@Root/types/inner/myhouse/MortgagePartnerProduct';
import qs from 'qs';

export const fetchMortgagePartnerProduct = createAsyncThunk(
    '/mortgageLoan/partnerProduct',
    async ({productTypes}: {productTypes: TMortgagePartnerProductType[]}) => {
        const response = await await mortgageLoanAxios.get(`/mortgage/partnerProduct`, {
            params: {
                productTypes,
            },
            paramsSerializer: (params) => {
                return qs.stringify(params, {arrayFormat: 'repeat'});
            },
        });

        return response?.data?.result;
    }
);

export type MortgageLoanType = {
    partnerProduct: MortgagePartnerProduct | null;
    fetchStatus: FETCH_STATUS;
};

const initialState: MortgageLoanType = {
    partnerProduct: null,
    fetchStatus: FETCH_STATUS.INITIAL,
} as MortgageLoanType;

export const mortgageLoanSlice = createSlice({
    name: 'mortgageLoan',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchMortgagePartnerProduct.fulfilled.type]: (
            state: MortgageLoanType,
            action: PayloadAction<MortgagePartnerProduct>
        ) => {
            state.fetchStatus = FETCH_STATUS.SUCCESS;
            const partnerProduct: MortgagePartnerProduct = action.payload;
            state.partnerProduct = partnerProduct;
        },
        [fetchMortgagePartnerProduct.pending.type]: (state: MortgageLoanType) => {
            state.fetchStatus = FETCH_STATUS.PENDING;
        },
        [fetchMortgagePartnerProduct.rejected.type]: (state: MortgageLoanType) => {
            state.fetchStatus = FETCH_STATUS.FAILURE;
        },
    },
});

export default mortgageLoanSlice.reducer;
